<template>
	<div><span class="biaoti">其他接口</span>
		<el-collapse >
			<el-collapse-item title="APP更新(FIR.IM)" name="1">
				<el-form label-width="80px" style="margin-top: 20px;">
					<!-- <el-form-item label="" class="touu" label-width="140px"></el-form-item> -->
					<el-form-item label="Token" label-width="180px">
						<el-input v-model="Token"></el-input>
					</el-form-item>
					<el-form-item label="安卓ID" label-width="180px">
						<el-input v-model="ID"></el-input>
					</el-form-item>
					<el-form-item label="苹果ID" label-width="180px">
						<el-input v-model="ipID"></el-input>
					</el-form-item>
					<el-button type="danger" size="small" style="margin: 20px;">提交</el-button>
				</el-form>
		</el-collapse-item>
		<el-collapse-item title="腾讯地图" name="2">
			<el-form label-width="80px"  style="margin-top: 20px;">
				<el-form-item label="Key" label-width="180px" style="margin-left:20px ;">
					<el-input v-model="ditu"></el-input>
				<el-form-item class="tishi" style="color: #737373;" >
					申请腾讯地图API</el-link>
				</el-form-item>
				</el-form-item>
				<el-button type="danger" size="small" style="margin: 20px;">提交</el-button>
			</el-form>
		</el-collapse-item>
		<el-collapse-item title="七牛云" name="3">
			<el-form label-width="80px"  style="margin-top: 20px;">
				<el-form-item label="开启七牛云" label-width="180px">
					<el-radio v-model="radio" label="1" style="margin-left: 12px;">开启</el-radio>
					<el-radio v-model="radio" label="2">关闭</el-radio>
					<el-form-item class="tishi" style="margin-left: 8px;">是否开启注册页的短信验证</el-form-item>
				</el-form-item>
				<el-form-item label="访问域名" label-width="180px" >
					<el-input v-model="yuming"></el-input>
				<el-form-item class="tishi" style="color: #737373;" >
					申请七牛云API</el-link>
				</el-form-item>
				</el-form-item>
				<el-form-item label="空间名称" label-width="180px" >
					<el-input v-model="kongjianming"></el-input>
				</el-form-item>
				<el-form-item label="AccessKey" label-width="180px" >
					<el-input v-model="AccessKey"></el-input>
				</el-form-item>
				<el-form-item label="SecretKey" label-width="180px" >
					<el-input v-model="SecretKey"></el-input>
					<el-form-item class="tishi" style="margin-left: 8px;">获取AccessKey/SecretKey</el-form-item>
				</el-form-item>
			</el-form>
			<el-button type="danger" size="small" style="margin: 20px;">提交</el-button>
		</el-collapse-item>
		</el-collapse>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				Token:'',ID:'',
				ipID:'',ditu:'',
				radio:"1",kongjianming:'',
				AccessKey:'',SecretKey:'',
				yuming:''
	};
	},
	methods: {
			Shanghu: function(e) {
				console.log(e)
			},
		}
	}
</script>

<style>
	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}

	el-card {
		padding: 20px !important;
	}
	.tishi{
		color:  #737373;;
	}
</style>
